export enum TabsSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}